import React from 'react';
import { useUser } from 'react-spotify-api'
import PersonalisedHeader from "./PersonalisedHeader";
import InputAndProcess from "./InputAndProcess";
import {ClipLoader} from "react-spinners";

function SpotifyLoggedInState({token}) {
    const { data, loading, error } = useUser();

    if (loading){
        return (
            <ClipLoader
                size={150}
                color={"#1db954"}
                loading={loading}
            />
        )
    }

    if (error){
        return <h4>Something went wrong signing into Spotify, please clear your cookies/site data and try again.</h4>
    }

    if(data){
        return (
            <div>
                <PersonalisedHeader
                    name={data.display_name}
                    img={data.images[0].url}
                    link={data.external_urls.spotify}
                />
                <InputAndProcess
                    id={data.id}
                    token={token}
                />
            </div>

        )
    }
    return <div>Something went wrong :(</div>
}

export default SpotifyLoggedInState;